import createCrudVuexModule from "@/store/crud";

export const managementSafeCountryMap = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/safe-country-map",
});

export const workspaceSafeCountryMap = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/safe-country-map",
});
